module.exports = __webpack_public_path__ + "img/group1.e1f67999.png";